import React, { useEffect, useState } from 'react'
import {
  Panel,
  ResultBorder,
  RollBorder,
  SeperateBorder,
} from './GameBoardStyles'
import { BACKGROUND_PROPS } from './interface'

function Background({ rollUnder, win, betId, lastProfit }: BACKGROUND_PROPS) {
  //TODO Refactor
  const [rollDegrees, setrollDegrees] = useState<number>(167)
  const [resultDegrees, setresultDegrees] = useState<number>(-167)
  const [rollBackground, setrollBackground] = useState<string>('')
  const [resultBackground, setresultBackground] = useState<string>('')
  const [isWin, setisWin] = useState<boolean>(false)
  const [load, setLoad] = useState<boolean>(true)

  const borderAnimAfterRollChange = (bg: string) => {
    const intervalTime = 10
    let x = 167
    bg === 'blue' ? setrollBackground('red') : setrollBackground('blue')
    const soundInterval = setInterval(() => {
      x += 5
      setrollDegrees(x)
      if (x >= 322) {
        clearInterval(soundInterval)
        return
      }
    }, intervalTime)
  }
  const borderAnimBeforeRollChange = (bg: string) => {
    // setrollBackground(bg)
    const intervalTime = 10
    let x = 322
    const soundInterval = setInterval(() => {
      x += 5
      setrollDegrees(x)
      if (x >= 472) {
        clearInterval(soundInterval)
        borderAnimAfterRollChange(bg)
        setrollDegrees(167)
        return
      }
    }, intervalTime)
  }

  //RESULT
  const borderAnimAfterWinChange = () => {
    const intervalTime = 10
    let x = -400
    setresultBackground('green')
    const soundInterval = setInterval(() => {
      x += 5
      setresultDegrees(x)
      if (x >= -322) {
        clearInterval(soundInterval)
        return
      }
    }, intervalTime)
  }
  const borderAnimBeforeWinChange = () => {
    const intervalTime = 10
    let x = -322
    isWin ? setresultBackground('green') : setresultBackground('grey')
    const soundInterval = setInterval(() => {
      x += 5
      setresultDegrees(x)
      if (x >= -167) {
        if (win) {
          borderAnimAfterWinChange()
        }
        setresultDegrees(-472)
        clearInterval(soundInterval)
        return
      }
    }, intervalTime)
  }

  useEffect(() => {
    if (rollUnder) {
      setrollBackground('blue')
      borderAnimBeforeRollChange('red')
    } else {
      setrollBackground('red')
      borderAnimBeforeRollChange('blue')
    }
  }, [rollUnder])

  useEffect(() => {
    if (betId !== '') {
      borderAnimBeforeWinChange()
      setLoad(false)
    }
  }, [betId])

  useEffect(() => {
    !win ? setisWin(false) : setisWin(true)
  }, [win])

  useEffect(() => {
    if (load && lastProfit > 0) {
      setresultBackground('green')
      setresultDegrees(-322)
    } else {
      setresultBackground('grey')
    }
  }, [load, lastProfit])
  return (
    <>
      <RollBorder deg={rollDegrees} background={rollBackground} />
      <SeperateBorder />
      <ResultBorder background={resultBackground} deg={resultDegrees} />
      <Panel />
    </>
  )
}
export default Background
